import { type FormEvent, useState } from "react";
import { Link } from "react-router";
import { Alert, Button, Field } from "@/components/ui";
import { authClient } from "@/lib/authClient";
import { errText, useT } from "@/lib/i18n";
import { AuthLayout } from "./AuthLayout";

export default function Register() {
  const t = useT();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError(t.errors.PASSWORD_MISMATCH ?? t.error);
      return;
    }
    setBusy(true);
    const r = await authClient.signUp.email({ name, email, password });
    setBusy(false);
    if (r.error) setError(errText(t, r.error.code));
    else setDone(true);
  }

  if (done)
    return (
      <AuthLayout title={t.verifyTitle}>
        <p className="text-muted">{t.verifyBody}</p>
        <Link to="/login" className="mt-6 inline-block text-sm font-semibold">
          {t.signIn}
        </Link>
      </AuthLayout>
    );

  return (
    <AuthLayout title={t.register}>
      <form onSubmit={submit} className="space-y-4">
        <Field
          label={t.name}
          name="name"
          autoComplete="name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Field
          label={t.email}
          name="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Field
          label={t.password}
          name="password"
          type="password"
          autoComplete="new-password"
          minLength={8}
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Field
          label={t.confirmPassword}
          name="confirm"
          type="password"
          autoComplete="new-password"
          minLength={8}
          required
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        {error ? <Alert kind="error">{error}</Alert> : null}
        <Button type="submit" className="w-full" loading={busy}>
          {t.createAccount}
        </Button>
      </form>
      <p className="mt-5 text-sm text-muted">
        {t.haveAccount}{" "}
        <Link to="/login" className="font-semibold text-text">
          {t.signIn}
        </Link>
      </p>
    </AuthLayout>
  );
}
